export const Endpoint = () => `/api/v4/user/default-license/`;
export declare const QueryKey: never;
export type Payload = {
    licenseId: string;
};
export type Response = void;
